import React from "react";
import { Box, Button, Typography } from "@mui/material";
import successImage from "../../../assets/images/website-flow/sucess.png";
import { useNavigate } from "react-router-dom";
import PaymentDialogue from "../../common/PaymentDialogue";
import i18next from "i18next";


const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    // height: "100vh",
    backgroundColor: "#F4F8FF",
    paddingTop: "4%",
    paddingBottom: "8%",
  },
  image: {
    width: "150px",
    height: "150px",
    marginBottom: "20px",
  },
  mainHeading: {
    fontSize: "24px",
    color: "black",
    fontFamily: "Tajawal-Bold",
    textAlign: "center",
  },
  subHeading: {
    fontSize: "16px",
    color: "black",
    fontFamily: "Tajawal-Bold",
    textAlign: "center",
    marginTop: "10px",
  },
};

const SuccessScreen = ({showPaymentModal, onClosePaymentModal, paymentResponse}) => {
  const navigate = useNavigate();
  return (
   
    <Box sx={styles.container}>
      {/* Success Image */}
      {showPaymentModal && paymentResponse &&  <PaymentDialogue showPaymentModal={showPaymentModal} onClose={onClosePaymentModal} paymentDetails={paymentResponse} />}
      <img src={successImage} alt="Success" style={styles.image} />

      {/* Main Heading */}
      <Typography sx={styles.mainHeading}>{i18next.t("ONBOARD_COMPLETE_PAGE_HEADING_1")}</Typography>

      {/* Sub Heading */}
      <Typography sx={styles.subHeading}>
        
        {i18next.t("ONBOARD_COMPLETE_PAGE_HEADING_2")}
        <Button onClick={() => navigate("/cpanel")}>{i18next.t("ONBOARD_COMPLETE_PAGE_LINK_1")}</Button>
      </Typography>
    </Box>
  );
};

export default SuccessScreen;
